import { render } from "./EditServices.vue?vue&type=template&id=a88d3e10&scoped=true"
import script from "./EditServices.vue?vue&type=script&lang=js"
export * from "./EditServices.vue?vue&type=script&lang=js"

import "./EditServices.vue?vue&type=style&index=0&id=a88d3e10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88d3e10"]])

export default __exports__